import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2, Link } from '@zola/zola-ui';

import './InformingGuestsModal.style.less';


const InformingGuestsModal = ({ hideModalFn }) => (
  <div id="inform-modal" className="inform-modal">
    <h3 className="modal__title">Wedding plans affected by COVID-19?</h3>
    <p className="modal__subtitle">We’re here for you. Check out a few quick ways you can keep guests informed on your website.</p>
    <ul className="tips__list">
      <li className="list-item"><i className="zolaicon zolaicon-checkmark"/>Add one of our suggested notes to announce any updates</li>
      <li className="list-item"><i className="zolaicon zolaicon-checkmark"/>Turn off online RSVP if your wedding date may change</li>
      <li className="list-item"><i className="zolaicon zolaicon-checkmark"/>Edit your travel and schedule pages with the latest info</li>
    </ul>
    <p>
      We also put together a guide with tips, email templates, and more that you can read <Link
        inline
        role="link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.zola.com/expert-advice/is-coronavirus-impacting-your-wedding-heres-what-to-do"
      >
        here
      </Link>.
    </p>
    <p><strong>Have questions?</strong> <Link inline href="mailto:support@zola.com">
      Reach out
    </Link> to your Zola advisor, Melissa. She’ll take care of you right away.</p>
    <ButtonV2 onClick={hideModalFn} className="modal__close-btn">Got It</ButtonV2>
  </div>
);

InformingGuestsModal.propTypes = {
  hideModalFn: PropTypes.func.isRequired,
};

export default InformingGuestsModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/InformingGuestsModal/InformingGuestsModal.jsx